import * as CookieConsent from "vanilla-cookieconsent"
import { cookieConsentConfig } from "./config"
import { initMixpanel, enableTracking, disableTracking } from "../analytics/mixpanel"
import {
  initGoogleAnalytics,
  enableGoogleAnalytics,
  disableGoogleAnalytics,
} from "../analytics/google_analytics"

let initialized = false

// Sync analytics providers (Mixpanel + GA4) with the `analytics` choice.
function syncAnalyticsConsent() {
  if (CookieConsent.acceptedCategory("analytics")) {
    enableTracking()
    enableGoogleAnalytics()
  } else {
    disableTracking()
    disableGoogleAnalytics()
  }
}

export function initCookieConsent() {
  if (initialized) return
  initialized = true

  // Init providers denied/opted-out first, then let consent callbacks flip on.
  initMixpanel()
  initGoogleAnalytics()

  CookieConsent.run({
    ...cookieConsentConfig,
    onFirstConsent: syncAnalyticsConsent,
    onConsent: syncAnalyticsConsent,
    onChange: syncAnalyticsConsent,
  })
}

export function hasAnalyticsConsent() {
  return CookieConsent.acceptedCategory("analytics")
}

export function hasMarketingConsent() {
  return CookieConsent.acceptedCategory("marketing")
}

export { CookieConsent }
